import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { StaticRoutePaths } from '../../Common/ClientRoutes';
import { Pages } from '../../../customPages/Pages';
import localStorage from '../../Common/LocalStorage';
import Wrapper from '../../Common/components/Wrapper';

class Body extends React.Component {
    redirectionHandler = () => {
        if (this.props.pathName !== StaticRoutePaths.LOGIN && !localStorage.getToken('token')) {
            if (this.props.pathName === StaticRoutePaths.LOGIN_FORGOTTEN_PASSWORD) {
                return (
                    <Route
                        path={StaticRoutePaths.LOGIN_FORGOTTEN_PASSWORD}
                        exact
                        render={props => <Pages.LoginPage pathName={props.location.pathname} />}
                    />
                );
            } else if (this.props.pathName === StaticRoutePaths.LOGIN_RESET_PASSWORD) {
                return (
                    <Route
                        path={StaticRoutePaths.LOGIN_RESET_PASSWORD}
                        exact
                        render={props => <Pages.LoginPage pathName={props.location.pathname} />}
                    />
                );
            } else if (this.props.pathName === StaticRoutePaths.RESET_PASSWORD) {
                return (
                    <Route
                        path={StaticRoutePaths.RESET_PASSWORD}
                        exact
                        render={props => <Pages.PasswordPage pathName={props.location.pathname} type="Reset" />}
                    />
                );
            } else if (this.props.pathName === StaticRoutePaths.CREATE_PASSWORD) {
                return (
                    <Route
                        path={StaticRoutePaths.CREATE_PASSWORD}
                        exact
                        render={props => <Pages.PasswordPage pathName={props.location.pathname} type="Create" />}
                    />
                );
            }

            return <Redirect to="/login" />;
        } else if (this.props.pathName === StaticRoutePaths.LOGIN && localStorage.getToken('token')) {
            return <Redirect to="/" />;
        }
    };

    generateRoutesHandler = redirectRoutes => {
        return (
            <Switch>
                {redirectRoutes}

                <Route path={StaticRoutePaths.LOGIN} exact render={props => <Pages.LoginPage pathName={props.location.pathname} />} />

                <Route path={StaticRoutePaths.HOME} exact render={() => <Pages.HomePage />} />

                <Route path={StaticRoutePaths.USERS} exact render={() => <Pages.UsersPage />} />

                <Route path={StaticRoutePaths.NEW_USER} exact render={() => <Pages.AddUserPage />} />

                <Route path={StaticRoutePaths.EDIT_USER + '/:userId'} exact render={() => <Pages.EditUserPage />} />

                <Route path={StaticRoutePaths.INFO_USER} exact render={() => <Pages.UserInfoPage />} />

                <Route path={StaticRoutePaths.INFO_DETAILS_USER} exact render={() => <Pages.UserDetailsPage />} />

                <Route path={StaticRoutePaths.INFO_PASSWORD_USER} exact render={() => <Pages.UserPasswordPage />} />

                <Route path={StaticRoutePaths.COMPANIES} exact render={() => <Pages.CompaniesPage />} />

                <Route path={StaticRoutePaths.NEW_COMPANY} exact render={() => <Pages.AddCompanyPage />} />

                <Route path={StaticRoutePaths.EDIT_COMPANY + '/:companyId'} exact render={() => <Pages.EditCompanyPage />} />

                <Route path={StaticRoutePaths.DETAILS_COMPANY + '/:companyId'} exact render={() => <Pages.CompanyDetailsPage />} />

                <Route path={StaticRoutePaths.INFO_COMPANY} exact render={() => <Pages.CompanyInfoPage />} />

                <Route path={StaticRoutePaths.INFO_NEW_COMPANY} exact render={() => <Pages.AddCompanyPage />} />

                <Route path={StaticRoutePaths.INFO_EDIT_COMPANY + '/:companyId'} exact render={() => <Pages.EditCompanyPage />} />

                <Route path={StaticRoutePaths.PHARMACIES} exact render={() => <Pages.PharmaciesPage />} />

                <Route path={StaticRoutePaths.STATISTICS} exact render={() => <Pages.StatisticsPage />} />

                <Route path={StaticRoutePaths.NEW_PHARMACY} exact render={() => <Pages.AddPharmacyPage />} />

                <Route path={StaticRoutePaths.EDIT_PHARMACY + '/:pharmacyId'} exact render={() => <Pages.EditPharmacyPage />} />

                <Route path={StaticRoutePaths.STATISTICS} exact render={() => <Pages.StatisticsPage />} />

                <Route path={StaticRoutePaths.PHARMACY_DETAILS + '/:pharmacyId'} exact render={() => <Pages.PharmacyDetailsPage />} />

                <Route
                    path={StaticRoutePaths.PHARMACY_DETAILS + '/:pharmacyId/add-pharmacy-service'}
                    exact
                    render={() => <Pages.AddPharmacyServicePage />}
                />

                <Route
                    path={StaticRoutePaths.PHARMACY_DETAILS + '/:pharmacyId/edit-pharmacy-service/:serviceId'}
                    exact
                    render={() => <Pages.EditPharmacyServicePage />}
                />

                <Route path={StaticRoutePaths.ORDERS} exact render={() => <Pages.OrdersPage />} />

                <Route path={StaticRoutePaths.ORDER_DETAILS + '/:orderId'} exact render={() => <Pages.OrderDetailsPage />} />

                <Route path={StaticRoutePaths.PATIENTS} exact render={() => <Pages.PatientsPage />} />

                <Route path={StaticRoutePaths.NEW_PATIENT} exact render={() => <Pages.AddPatientPage />} />

                <Route path={StaticRoutePaths.DETAILS_PATIENT + '/:companyId'} exact render={() => <Pages.PatientDetailsPage />} />

                <Route path={StaticRoutePaths.DETAILS_PATIENT + '/:companyId/print-page'} exact render={() => <Pages.PatientPrintDetailsPage />} />

                <Route path={StaticRoutePaths.EDIT_PATIENT + '/:companyId'} exact render={() => <Pages.EditPatientPage />} />
            </Switch>
        );
    };

    render() {
        return <Wrapper>{this.generateRoutesHandler(this.redirectionHandler())}</Wrapper>;
    }
}

export default Body;



// WEBPACK FOOTER //
// ./src/customModules/Layout/components/Body.js